import styled, { css } from 'styled-components';
import { Button as MuiButton } from '@material-ui/core';

export const buttonStyle = css`
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.common.white};
  border-radius: ${({ theme }) => theme.config.defaultBorderRadius};
  border: none;
  padding: 1.2rem 2rem;
  font-family: ${({ theme }) => theme.config.secondaryFontFamily};
  font-size: ${({ theme }) => theme.typography.bodyMd.fontSize};
  white-space: nowrap;
  &:hover {
    background: ${({ theme }) => theme.palette.primary.dark};
  }
  &:disabled {
    background: ${({ theme }) => theme.palette.grey['200']};
    color: ${({ theme }) => theme.palette.common.white};
  }
  @media print {
    display: none;
  }
`;

export const PrimaryVariantButton = styled(MuiButton)`
  ${buttonStyle};
`;
